import script from "./TheSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./TheSidebar.vue?vue&type=style&index=0&id=245122f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/app-registration/app-registration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245122f0"]])

export default __exports__